<template>
  <div class="vd-gl-content">
    <!-- 检索条件 -->
    <a-row class="vd-toolbar">
      <a-col class="vd-bar">
        <a-form layout="inline">
          <a-form-item>
            <a-tooltip title="群状态">
              <a-select
                style="width: 116px"
                v-model="searchForm.groupStatus"
                :allowClear="true"
                placeholder="群状态"
              >
                <a-select-option key="normal">正常</a-select-option>
                <a-select-option key="close">已解散</a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item>

          <a-form-item>
            <a-tooltip title="群号">
              <a-input
                class="vd-input-xs"
                placeholder="群号"
                v-model="searchForm.groupQq"
              />
            </a-tooltip>
          </a-form-item>

          <a-form-item>
            <a-tooltip title="负责人工号">
              <a-input
                class="vd-input-xs"
                placeholder="负责人工号"
                v-model="searchForm.code"
              />
            </a-tooltip>
          </a-form-item>

          <a-form-item>
            <a-tooltip title="群所属地区">
              <a-cascader
                style="width: 216px"
                :options="areaTree"
                v-model="searchForm.areaPath"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }"
                placeholder="群所属地区"
                :change-on-select="true"
              />
            </a-tooltip>
          </a-form-item>

          <a-form-item>
            <a-tooltip title="群所属项目">
              <a-select
                style="width: 116px"
                :allowClear="true"
                placeholder="群所属项目"
                v-model="searchForm.category"
              >
                <template v-for="item in subList">
                  <a-select-option :key="item.id">
                    {{ item.nickname }}
                  </a-select-option>
                </template>
              </a-select>
            </a-tooltip>
          </a-form-item>

          <a-form-item>
            <a-tooltip title="群机器人所属地区">
              <a-select
                style="width: 116px"
                v-model="searchForm.loginQq"
                placeholder="归属机器人"
              >
                <template v-for="(item, index) in areaList">
                  <a-select-option :value="item.login_qq" :key="index">
                    {{ item.zh }}
                  </a-select-option>
                </template>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <a-form-item :wrapper-col="wrapperCol">
            <a-button type="primary" icon="search" @click="searchData" />
          </a-form-item>
          <a-form-item :wrapper-col="wrapperCol">
            <a-tooltip title="重置搜索条件">
              <a-button type="danger" icon="redo" @click="searchRedo" />
            </a-tooltip>
          </a-form-item>
          <a-form-item :wrapper-col="wrapperCol">
            <a-button type="primary" @click="exportData"> 导出数据</a-button>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col class="vd-bar">
        <a-form layout="inline">
          <a-form-item label="时间区间">
            <a-range-picker
              :default-value="searchForm.defaultTime"
              v-model="searchForm.defaultTime"
              format="YYYY/MM/DD"
              @change="dateChange"
            />
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <!-- 内容主体 -->
    <a-table
      :pagination="pagination"
      :data-source="list"
      :loading="loading"
      :scroll="{ x: 2400 }"
      row-key="id"
    >
      <template slot="footer">
        总人数: {{ totalInfo.num }} 总去重: {{ totalInfo.realNum }} 总流转:
        {{ totalInfo.transIn }} 总新增: {{ totalInfo.increase }} 总退群:
        {{ totalInfo.decrease }} 总消息人数:
        {{ totalInfo.messageMemberCount }} 总消息数:
        {{ totalInfo.messageCount }}
      </template>
      <a-table-column
        title="群号"
        align="center"
        fixed="left"
        data-index="group_qq"
      />
      <a-table-column title="群名" fixed="left" data-index="group_name" />
      <a-table-column
        title="地区"
        align="center"
        fixed="left"
        data-index="group_area"
      />
      <a-table-column
        title="项目"
        align="center"
        fixed="left"
        data-index="group_category"
      />

      <a-table-column-group title="归属人信息">
        <a-table-column title="工号" align="center" data-index="username" />
        <a-table-column title="姓名" align="center" data-index="nickname" />
        <a-table-column title="地区" align="center" data-index="area_name" />
      </a-table-column-group>

      <a-table-column title="群人数" data-index="num" />
      <a-table-column title="去重人数" data-index="real_num" />
      <a-table-column title="流入" data-index="trans_in" />
      <a-table-column title="流出" data-index="trans_out" />
      <a-table-column title="新增" data-index="increase">
        <template slot-scope="record">
          <a-icon type="caret-up" style="color:#FF4D4F" />
          {{ record }}
        </template>
      </a-table-column>
      <a-table-column title="退群" data-index="decrease">
        <template slot-scope="record">
          <a-icon type="caret-down" style="color:#3f8600" />
          {{ record }}
        </template>
      </a-table-column>
      <a-table-column
        title="消息人数"
        align="center"
        data-index="message_member_count"
      />
      <a-table-column
        title="消息数"
        align="center"
        data-index="message_count"
      />
      <a-table-column title="状态" align="center" fixed="right">
        <template slot-scope="record">
          <template v-if="record.delete_time === 0">
            <a-tooltip
              :title="'邀请时间' + $FormatUtil.timestamp2date(record.add_time)"
            >
              <a-tag color="blue"> 正常</a-tag>
            </a-tooltip>
          </template>
          <template v-else>
            <a-tooltip
              :title="
                '解散时间' + $FormatUtil.timestamp2date(record.delete_time)
              "
            >
              <a-tag color="red"> 已解散</a-tag>
            </a-tooltip>
          </template>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { get_sub } from '@/api'
import { my_group, export_group } from '@/api/qq'
import { get_area_tree } from '@/api/auth'
import store from '@/store'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
  name: 'MyGroup',
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      areaList: [],
      areaTree: [],
      subList: [],
      list: [],
      totalInfo: {
        num: '--',
        realNum: '--',
        transIn: '--',
        increase: '--',
        decrease: '--',
        messageMemberCount: '--',
        messageCount: '--',
      },
      searchForm: {
        groupQq: '',
        code: '',
        loginQq: undefined,
        areaPath: [],
        groupStatus: undefined,
        category: undefined,
        defaultTime: [moment().startOf('months'), moment().endOf('months')],
      },
      loading: false,
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        hideOnSinglePage: true,
        showTotal: (total) => `总共 ${total} 条`,
        onChange: (page) => {
          this.pagination.current = page
        },
      },
    }
  },
  created() {
    this.areaList = store.getters.qqRoot
    this.getData()
    // 获取下拉中的数据
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree
      }
    })
    get_sub('item_type').then((res) => {
      if (res.code === 1) {
        this.subList = res.list
      }
    })
  },
  methods: {
    moment,
    getData() {
      this.loading = true
      my_group({
        code: this.searchForm.code,
        group_status: this.searchForm.groupStatus,
        group_qq: this.searchForm.groupQq,
        login_qq: this.searchForm.loginQq,
        category: this.searchForm.category,
        area_path: this.searchForm.areaPath,
        date_range: this.searchForm.defaultTime,
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.list = res.list
          this.pagination.total = res.total
          this.totalInfo = res.totalInfo
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    searchData() {
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    searchRedo() {
      // 重置数据
      this.searchForm.groupQq = ''
      this.searchForm.code = ''
      this.searchForm.loginQq = undefined
      this.searchForm.areaPath = []
      this.searchForm.category = undefined
      this.searchForm.defaultTime = [
        moment().startOf('months'),
        moment().endOf('months'),
      ]
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    exportData() {
      export_group({
        code: this.searchForm.code,
        group_qq: this.searchForm.groupQq,
        login_qq: this.searchForm.loginQq,
        category: this.searchForm.category,
        area_path: this.searchForm.areaPath,
        date_range: this.searchForm.defaultTime,
      }).then((res) => {
        if (res.type === 'application/json') {
          let reader = new FileReader()
          reader.readAsText(res, 'utf-8')
          reader.addEventListener('loadend', () => {
            let msg = JSON.parse(reader.result)
            this.$message.error(msg.msg)
          })
        } else {
          const disposition = res.headers['content-disposition']
          let fileName = disposition.substring(
            disposition.indexOf('filename=') + 9,
            disposition.length
          )
          fileName = decodeURIComponent(fileName)
          let link = document.createElement('a')
          link.style.display = 'none'
          let url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.ms-excel',
            })
          )
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
    dateChange(dates) {
      console.log(dates)
      this.defaultTime = dates
    },
  },
}
</script>

<style scoped></style>
